import { Box, Divider, Typography } from "@mui/material";
import Logo from "../logo/Logo";
import Pathname from "./Pathname";
import UserAvatar from "./UserAvatar";
import { Link } from "react-router-dom";
import { HeadsetMicRounded } from "@mui/icons-material";
import useResponsive from "../hooks/useResponsive";
import { COLORS } from "../../ui/Theme";
import useCurrentPath from "../hooks/useCurrentPath";

const Header = () => {
  const { isMd } = useResponsive();
  const { route1 } = useCurrentPath();

  return (
    <Box
      sx={{
        position: "sticky",
        top: 0,
        zIndex: 2,
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        height: "58px",
        backgroundColor: "#fff",
        px: "24px",
        py: "20px",
        border: "1px solid #eee",
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 4,
        }}
      >
        <Logo />

        {isMd && (
          <>
            <Divider orientation="vertical" flexItem />
            <Pathname />
          </>
        )}
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: 2,
        }}
      >
        <Link
          to={"ticket"}
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "5px",
          }}
        >
          <Box
            sx={{
              bgcolor: route1?.route === "ticket" && COLORS.SOFTBLUE,
              color: route1?.route === "ticket" && COLORS.BLUE,
              borderRadius: "12px",
              padding: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: "5px",
              cursor: "pointer",
              ":hover": {
                bgcolor: COLORS.SOFTGRAY,
              },
            }}
          >
            {isMd && <Typography fontSize={"20px"}>تیکت</Typography>}
            <HeadsetMicRounded
              sx={{
                color:
                  route1?.route === "ticket" ? COLORS.BLUE : COLORS.DARKGRAY,
                width: "24px",
              }}
            />
          </Box>
        </Link>
        <UserAvatar />
      </Box>
    </Box>
  );
};

export default Header;
